import React from "react";

import { Img, List } from "components";

const QuickLookDialogRatingbar = (props) => {
  return (
    <>
      <List className={props.className} orientation="horizontal">
        <div className="flex flex-col items-center justify-start w-full">
          <div className="flex flex-col items-center justify-start w-[42px] md:w-full">
            <Img
              className="h-[41px] w-[42px]"
              src="images/img_star5_5.svg"
              alt="starfive"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-start w-full">
          <div className="flex flex-col items-center justify-start w-[42px] md:w-full">
            <Img
              className="h-[41px] w-[42px]"
              src="images/img_star5_5.svg"
              alt="starfive"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-start w-full">
          <div className="flex flex-col items-center justify-start w-[42px] md:w-full">
            <Img
              className="h-[41px] w-[42px]"
              src="images/img_star5_5.svg"
              alt="starfive"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-start w-full">
          <div className="flex flex-col items-center justify-start w-[42px] md:w-full">
            <Img
              className="h-[41px] w-[42px]"
              src="images/img_star5_5.svg"
              alt="starfive"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-start w-full">
          <Img
            className="h-[41px] w-[42px]"
            src="images/img_star9_41x42.svg"
            alt="starnine"
          />
        </div>
      </List>
    </>
  );
};

QuickLookDialogRatingbar.defaultProps = {};

export default QuickLookDialogRatingbar;
